import React from "react";
import styled from "styled-components";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
}

const SVG = styled.svg``;

export const IconReset: React.FC<IProps> = ({color, ...rest}) => (
	<SVG viewBox="0 0 8 9" fill="none" {...rest}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 4V4.5H1V4C1 2.3455 2.3455 1 4 1C5.6545 1 7 2.3455 7 4C7 5.6545 5.6545 7 4 7H3.5V6.03746L1.65994 7.5L3.5 8.96253V8H4C6.2055 8 8 6.2055 8 4C8 1.7945 6.2055 0 4 0C1.7945 0 0 1.7945 0 4Z"
			fill={color}
		/>
	</SVG>
);

IconReset.defaultProps = {
	width: 8,
	height: 9,
	color: "currentColor",
};
